import { z } from 'zod';
import { metadata } from './content/helpers';

const i18nSchema = z.object({
  contacts: z.array(
    z.object({
      label: z.string(),
      href: z.string(),
    })
  ),
  operatingHours: z.string(),
});

export const officeSchema = z
  .object({
    id: z.number().int().positive().optional(),
    name: z.string().min(1).max(100),
    city_id: z.number().int().optional(),
    phone_id: z.number({ message: 'Primary office phone is required.' }).int().positive('Please select a phone number.'),
    place_id: z.string().nullish(),
    published_at: z.date().nullable(),
    headquarter: z.boolean(),
    // route is a form-only transport field: it carries the desired page slug from the UI wizard
    // into createOfficePageInTransaction(). It is NOT a column in the offices table and is
    // explicitly excluded from the Prisma create/update calls in packages/database/src/offices.ts.
    route: z.string().optional(),
    content: z.object({
      metadata: metadata,
      data: z.object({
        address: z.object({
          addr1: z.string(),
          addr2: z.string(),
          city: z.string(),
          postal_code: z.string(),
          state: z.object({
            name: z.string(),
            abbrev: z.string(),
          }),
          country: z.object({
            name: z.string(),
            code: z.string(),
          }),
        }),
        picture: z.string({ message: 'Office picture is required.' }).min(1, 'Office picture is required.'),
        social: z
          .array(
            z.object({
              icon: z.string(),
              href: z.string(),
            })
          )
          .min(1),
        i18n: z.object({
          en: i18nSchema,
          es: i18nSchema,
        }),
      }),
    }),
  })
  .superRefine((data, ctx) => {
    if (
      data.content.data.address.country.code === 'US' &&
      !data.content.data.address.state.name
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'State is required for US offices',
        path: ['content', 'data', 'address', 'state', 'name'],
      });
    }
  });

export type OfficeInput = z.infer<typeof officeSchema>;
